"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFieldFactory = void 0;
const errors_1 = require("../errors");
function mapFieldFactory(options) {
    var _a;
    if (!options.name) {
        throw new errors_1.FieldError('Field must have a name.');
    }
    if (!options.subField) {
        throw new errors_1.FieldError('Map field must have a subfield.');
    }
    function getDefault() {
        if (typeof options.defaultValue === 'function') {
            return (options.defaultValue());
        }
        if (options.defaultValue) {
            return options.defaultValue;
        }
        return undefined;
    }
    function validate(value) {
        // Explicitly check for `null` since `typeof null` is "object"
        // We are also explicity forbidding arrays
        if (typeof value !== 'object' || value === null || Array.isArray(value)) {
            throw new errors_1.ValidationError(`Field "${options.name}" must be a map`);
        }
        // Validate individual key-value pairs
        Object.values(value).forEach(subvalue => {
            options.subField.validate(subvalue);
        });
    }
    const applySubfieldToMap = (method) => (value) => {
        if (value === undefined) {
            return undefined;
        }
        return Object.entries(value).reduce((result, [key, subvalue]) => {
            result[key] = method(subvalue);
            return result;
        }, {});
    };
    const applySubfieldFromMap = (method) => (value) => {
        if (value === undefined || value === null) {
            return undefined;
        }
        return Object.entries(value).reduce((result, [key, subvalue]) => {
            result[key] = method(subvalue);
            return result;
        }, {});
    };
    return {
        name: options.name,
        getDefault,
        validate,
        isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : false,
        fromDb: applySubfieldFromMap(options.subField.fromDb),
        fromApi: applySubfieldFromMap(options.subField.fromApi),
        toDb: applySubfieldToMap(options.subField.toDb),
        toApi: applySubfieldToMap(options.subField.toApi),
    };
}
exports.mapFieldFactory = mapFieldFactory;
//# sourceMappingURL=map.js.map